module.exports = webappBundle("teams/components/org-chart-v3/org-chart-v3.component.css");